import * as React from "react";
import {useEffect, useState} from "react";
import {IPlanCashFlow, PortfolioApi} from "../../api/PortfolioApi";
import {IRangeValue} from "../../api/InFormReportingApi";
import {formatShortDate} from "../../utils/dateUtil";
import {LoadingSpinner} from "../icons/LoadingSpinner.component";
import {getNumber} from "../../utils/commonUtil";
import {IPlanMarketValueLineChart, PlanMarketValueLineChart} from "./PlanMarketValueLineChart";
import {PlanCashFlowBarChart} from "./PlanCashFlowBarChart";
import {IHorizontalBarChart} from "../common/HorizontalBarChart.component";
import {isClientUser} from "../../utils/sessionUtil";

interface IFinancialReconciliationTabProps {
    clientPortfolioAccess: boolean;
    clientNetCashFlowsAccess: boolean;
}

export const FinancialReconciliationTab: React.FunctionComponent<IFinancialReconciliationTabProps> = (props) => {
    const [planMarketValues, setPlanMarketValues] = useState<IPlanMarketValueLineChart[]>([]);
    const [planCashFlows, setPlanCashFlows] = useState<IHorizontalBarChart[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    const getPlanMarketValueData = (productData: IRangeValue[]): IPlanMarketValueLineChart[] => {
        return productData
            .map((productValue: IRangeValue) => {
                return {
                    asOfDate: formatShortDate(productValue.date),
                    value: getNumber(productValue.value)
                };
            });

    };

    const getPlanCashFlowData = (productData: IPlanCashFlow[]): IHorizontalBarChart[] => {
        return productData
            .map((productValue: IPlanCashFlow) => {
                return {
                    label: formatShortDate(productValue.date),
                    value: getNumber(productValue.netCashFlow)
                };
            });
    };

    useEffect(() => {
        PortfolioApi.getCurrentPlanMarketValues()
            .then(response => {
                const formatedResponse = getPlanMarketValueData(response);
                setPlanMarketValues(formatedResponse);
                setLoading(false);
            }).catch(() => setLoading(false));
    }, []);

    useEffect(() => {
        PortfolioApi.getCurrentPlanCashFlow()
            .then(response => {
                const formatedResponse = getPlanCashFlowData(response);
                setPlanCashFlows(formatedResponse);
                setLoading(false);
            }).catch(() => setLoading(false));
    }, []);

    const shouldRenderCashFlowChart = planCashFlows.length > 0 && (!isClientUser() || props.clientNetCashFlowsAccess);

    if(loading) {
        return <LoadingSpinner/>;
    }

    return <div className="financial-reconciliation-tab__container"
                data-testid="financial-reconciliation-tab__container">
        {planMarketValues.length > 0 && <PlanMarketValueLineChart planMarketValues={planMarketValues}/>}
        {shouldRenderCashFlowChart && <PlanCashFlowBarChart
            data={planCashFlows}
            clientPortfolioAccess={props.clientPortfolioAccess}
            clientNetCashFlowsAccess={props.clientNetCashFlowsAccess}
        />}
    </div>;
};
